import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-diamond, square-45-degrees"} maskId="square-filled-radius-0-stroke-1-IconFormDiamond"><path d="M22.707 12L12 22.707L1.29297 12L12 1.29297L22.707 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormDiamond;
